import { render, staticRenderFns } from "./DeclineEmail.vue?vue&type=template&id=dda192d0&scoped=true"
import script from "./DeclineEmail.vue?vue&type=script&lang=js"
export * from "./DeclineEmail.vue?vue&type=script&lang=js"
import style0 from "./DeclineEmail.vue?vue&type=style&index=0&id=dda192d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda192d0",
  null
  
)

export default component.exports